<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-export"
    fill-dot
  >
    <v-row
      no-gutters
      align="center"
      class="pr-12 mb-2 mt-n2 d-flex justify-center"
      :class="{ 'flex-column': $vuetify.display.smAndDown }"
    >
      <v-col md="8">
        <div class="text-subtitle-1">
          {{ $t('lead-timeline.export.title') }}
        </div>
        <div class="text-grey text--small">
          {{ $t('lead-timeline.export.subtitle') }}
        </div>
      </v-col>
      <v-col
        class="text-right text-grey text--small pr-8"
        :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
        md="4"
      >
        {{ formatDate(data.createdAt) }}
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: null },
  },
}
</script>

<style scoped>
.text--small {
  font-size: 15px;
}
</style>
